module.exports = __webpack_public_path__ + "img/pellets-banner-1280w.69b7426.webp";